export const types = {
  consultation: 'Consulta',
  sadt: 'SP/SADT',
  simple: 'Simples',
};

export const longNames = {
  consultation: 'Guia de consulta',
  sadt: 'Guia SP/SADT',
  simple: 'Guia simples',
};

export function getName(value) {
  return types[value] || value;
}

export function getLongName(value) {
  return longNames[value] || value;
}
